// Pukul Jawaban! - Whack-a-Mole Educational Game Data

import { logger } from "./logger";
import { getVoiceLang } from "./voicePref";
export const WHACK_LEVELS = [
  {
    id: 1,
    name: "Kenal Angka",
    icon: "\uD83D\uDD22",
    color: "#4ECDC4",
    moleStay: 3500,
    spawnInterval: 1800,
    timePerQuestion: 15,
    badge: "Jago Angka",
    questions: [
      { q: "Mana angka 3?", correct: "3", pool: ["1","2","3","4","5","6","7","8","9"] },
      { q: "Mana angka 7?", correct: "7", pool: ["1","3","5","7","8","9","2","4","6"] },
      { q: "Mana angka 1?", correct: "1", pool: ["1","2","3","4","5","6","7","8","9"] },
      { q: "Mana angka 5?", correct: "5", pool: ["1","2","3","4","5","6","7","8","9"] },
      { q: "Mana angka 9?", correct: "9", pool: ["1","2","3","4","5","6","7","8","9"] },
    ],
  },
  {
    id: 2,
    name: "Kenal Huruf",
    icon: "\uD83D\uDD24",
    color: "#FF6B6B",
    moleStay: 3200,
    spawnInterval: 1600,
    timePerQuestion: 15,
    badge: "Jago Huruf",
    questions: [
      { q: "Mana huruf B?", correct: "B", pool: ["A","B","C","D","E","F","G","H","I"] },
      { q: "Mana huruf G?", correct: "G", pool: ["A","B","C","D","E","F","G","H","I"] },
      { q: "Mana huruf A?", correct: "A", pool: ["A","B","C","D","E","F","G","H","I"] },
      { q: "Mana huruf E?", correct: "E", pool: ["A","B","C","D","E","F","G","H","I"] },
      { q: "Mana huruf D?", correct: "D", pool: ["A","B","C","D","E","F","G","H","I"] },
    ],
  },
  {
    id: 3,
    name: "Kenal Warna",
    icon: "\uD83C\uDFA8",
    color: "#FF69B4",
    moleStay: 3000,
    spawnInterval: 1500,
    timePerQuestion: 14,
    badge: "Jago Warna",
    questions: [
      { q: "Pilih warna Kuning!", correct: "\uD83D\uDFE1", pool: ["\uD83D\uDD34","\uD83D\uDD35","\uD83D\uDFE1","\uD83D\uDFE2","\uD83D\uDFE0","\uD83D\uDFE3","\u26AA","\uD83D\uDFE4","\u26AB"] },
      { q: "Pilih warna Merah!", correct: "\uD83D\uDD34", pool: ["\uD83D\uDD34","\uD83D\uDD35","\uD83D\uDFE1","\uD83D\uDFE2","\uD83D\uDFE0","\uD83D\uDFE3","\u26AA","\uD83D\uDFE4","\u26AB"] },
      { q: "Pilih warna Biru!", correct: "\uD83D\uDD35", pool: ["\uD83D\uDD34","\uD83D\uDD35","\uD83D\uDFE1","\uD83D\uDFE2","\uD83D\uDFE0","\uD83D\uDFE3","\u26AA","\uD83D\uDFE4","\u26AB"] },
      { q: "Pilih warna Hijau!", correct: "\uD83D\uDFE2", pool: ["\uD83D\uDD34","\uD83D\uDD35","\uD83D\uDFE1","\uD83D\uDFE2","\uD83D\uDFE0","\uD83D\uDFE3","\u26AA","\uD83D\uDFE4","\u26AB"] },
      { q: "Pilih warna Ungu!", correct: "\uD83D\uDFE3", pool: ["\uD83D\uDD34","\uD83D\uDD35","\uD83D\uDFE1","\uD83D\uDFE2","\uD83D\uDFE0","\uD83D\uDFE3","\u26AA","\uD83D\uDFE4","\u26AB"] },
    ],
  },
  {
    id: 4,
    name: "Bentuk Dasar",
    icon: "\u2B50",
    color: "#FFD700",
    moleStay: 2800,
    spawnInterval: 1400,
    timePerQuestion: 13,
    badge: "Jago Bentuk",
    questions: [
      { q: "Mana Lingkaran?", correct: "\u2B55", pool: ["\u2B55","\u2B1C","\uD83D\uDD3A","\u2B50","\u2764\uFE0F","\uD83D\uDC8E","\u2B1B","\uD83D\uDD36","\uD83D\uDD37"] },
      { q: "Mana Bintang?", correct: "\u2B50", pool: ["\u2B55","\u2B1C","\uD83D\uDD3A","\u2B50","\u2764\uFE0F","\uD83D\uDC8E","\u2B1B","\uD83D\uDD36","\uD83D\uDD37"] },
      { q: "Mana Segitiga?", correct: "\uD83D\uDD3A", pool: ["\u2B55","\u2B1C","\uD83D\uDD3A","\u2B50","\u2764\uFE0F","\uD83D\uDC8E","\u2B1B","\uD83D\uDD36","\uD83D\uDD37"] },
      { q: "Mana Hati?", correct: "\u2764\uFE0F", pool: ["\u2B55","\u2B1C","\uD83D\uDD3A","\u2B50","\u2764\uFE0F","\uD83D\uDC8E","\u2B1B","\uD83D\uDD36","\uD83D\uDD37"] },
      { q: "Mana Kotak?", correct: "\u2B1C", pool: ["\u2B55","\u2B1C","\uD83D\uDD3A","\u2B50","\u2764\uFE0F","\uD83D\uDC8E","\u2B1B","\uD83D\uDD36","\uD83D\uDD37"] },
    ],
  },
  {
    id: 5,
    name: "Penjumlahan",
    icon: "\u2795",
    color: "#E67E22",
    moleStay: 2600,
    spawnInterval: 1300,
    timePerQuestion: 12,
    badge: "Jago Hitung",
    questions: [
      { q: "1 + 2 = ?", correct: "3", pool: ["1","2","3","4","5","6","7","8","9"] },
      { q: "3 + 4 = ?", correct: "7", pool: ["5","6","7","8","9","3","4","1","2"] },
      { q: "2 + 2 = ?", correct: "4", pool: ["2","3","4","5","6","7","8","1","9"] },
      { q: "5 + 1 = ?", correct: "6", pool: ["4","5","6","7","8","3","2","1","9"] },
      { q: "4 + 3 = ?", correct: "7", pool: ["5","6","7","8","9","4","3","2","1"] },
    ],
  },
  {
    id: 6,
    name: "English",
    icon: "\uD83C\uDF0D",
    color: "#9B59B6",
    moleStay: 2400,
    spawnInterval: 1200,
    timePerQuestion: 12,
    badge: "English Star",
    questions: [
      { q: "Pilih 'CAT'", correct: "CAT", pool: ["CAT","DOG","FISH","BIRD","COW","PIG","HEN","ANT","BEE"] },
      { q: "Mana warna BLUE?", correct: "\uD83D\uDD35", pool: ["\uD83D\uDD34","\uD83D\uDD35","\uD83D\uDFE1","\uD83D\uDFE2","\uD83D\uDFE0","\uD83D\uDFE3","\u26AA","\uD83D\uDFE4","\u26AB"] },
      { q: "Pilih 'APPLE'", correct: "APPLE", pool: ["APPLE","BALL","CAKE","DOOR","EGG","FISH","GATE","HAT","INK"] },
      { q: "Mana angka THREE?", correct: "3", pool: ["1","2","3","4","5","6","7","8","9"] },
      { q: "Pilih 'SUN'", correct: "SUN", pool: ["SUN","MOON","STAR","RAIN","WIND","SNOW","SEA","SKY","FOG"] },
    ],
  },
  {
    id: 7,
    name: "Perkalian",
    icon: "\u2716\uFE0F",
    color: "#9333EA",
    moleStay: 2500,
    spawnInterval: 1300,
    timePerQuestion: 12,
    badge: "Master Kali",
    questions: [
      { q: "2 x 3 = ?", correct: "6", pool: ["4","5","6","7","8","9","10","12","15"] },
      { q: "4 x 2 = ?", correct: "8", pool: ["4","6","7","8","9","10","12","14","16"] },
      { q: "5 x 5 = ?", correct: "25", pool: ["10","15","20","25","30","35","40","45","50"] },
      { q: "3 x 4 = ?", correct: "12", pool: ["6","8","9","10","12","14","16","18","20"] },
      { q: "6 x 2 = ?", correct: "12", pool: ["8","10","11","12","14","15","16","18","20"] },
    ],
  },
  {
    id: 8,
    name: "Pengurangan",
    icon: "\u2796",
    color: "#06B6D4",
    moleStay: 2800,
    spawnInterval: 1400,
    timePerQuestion: 12,
    badge: "Jago Kurang",
    questions: [
      { q: "10 - 3 = ?", correct: "7", pool: ["3","4","5","6","7","8","9","10","11"] },
      { q: "8 - 5 = ?", correct: "3", pool: ["1","2","3","4","5","6","7","8","9"] },
      { q: "15 - 7 = ?", correct: "8", pool: ["5","6","7","8","9","10","11","12","13"] },
      { q: "20 - 6 = ?", correct: "14", pool: ["10","12","13","14","15","16","18","20","22"] },
      { q: "12 - 4 = ?", correct: "8", pool: ["4","5","6","7","8","9","10","11","12"] },
    ],
  },
  {
    id: 9,
    name: "Tebak Bentuk",
    icon: "\uD83D\uDD37",
    color: "#F59E0B",
    moleStay: 2800,
    spawnInterval: 1400,
    timePerQuestion: 13,
    badge: "Sang Geometri",
    questions: [
      { q: "Mana segitiga?", correct: "\uD83D\uDD3A", pool: ["\u2B1B","\u26AA","\uD83D\uDD37","\uD83D\uDD3A","\uD83D\uDD36","\u2B50","\u2764\uFE0F","\uD83D\uDD38","\uD83D\uDD39"] },
      { q: "Mana lingkaran?", correct: "\u26AA", pool: ["\u26AA","\u2B1B","\uD83D\uDD37","\uD83D\uDD3A","\u2B50","\u2764\uFE0F","\uD83D\uDD36","\uD83D\uDD38","\uD83D\uDD39"] },
      { q: "Mana bintang?", correct: "\u2B50", pool: ["\u2B1B","\u26AA","\uD83D\uDD37","\u2B50","\uD83D\uDD3A","\u2764\uFE0F","\uD83D\uDD36","\uD83D\uDD38","\uD83D\uDD39"] },
      { q: "Mana hati?", correct: "\u2764\uFE0F", pool: ["\u2B1B","\u26AA","\u2764\uFE0F","\uD83D\uDD3A","\u2B50","\uD83D\uDD37","\uD83D\uDD36","\uD83D\uDD38","\uD83D\uDD39"] },
      { q: "Mana kotak?", correct: "\u2B1B", pool: ["\u2B1B","\u26AA","\uD83D\uDD37","\uD83D\uDD3A","\u2B50","\u2764\uFE0F","\uD83D\uDD36","\uD83D\uDD38","\uD83D\uDD39"] },
    ],
  },
  {
    id: 10,
    name: "Master Campuran",
    icon: "\uD83C\uDFC6",
    color: "#DC2626",
    moleStay: 2200,
    spawnInterval: 1200,
    timePerQuestion: 12,
    badge: "Juara Sejati",
    questions: [
      { q: "7 + 5 = ?", correct: "12", pool: ["8","10","11","12","13","14","15","16","18"] },
      { q: "Mana 'STAR'?", correct: "STAR", pool: ["STAR","BEAR","CAR","FAR","JAR","BAR","WAR","TAR","PAR"] },
      { q: "Mana huruf K?", correct: "K", pool: ["A","B","K","M","P","R","S","T","Z"] },
      { q: "9 - 4 = ?", correct: "5", pool: ["3","4","5","6","7","8","9","10","11"] },
      { q: "Mana 'CAT'?", correct: "CAT", pool: ["CAT","BAT","HAT","RAT","MAT","SAT","FAT","TAP","MAP"] },
      { q: "3 x 3 = ?", correct: "9", pool: ["6","7","8","9","10","12","15","18","20"] },
      { q: "Mana angka 8?", correct: "8", pool: ["1","2","3","4","5","6","7","8","9"] },
    ],
  },
];

export const BUBBLE_COLORS = [
  "#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4", "#FFEAA7",
  "#DDA0DD", "#98D8C8", "#F7DC6F", "#FF69B4", "#FFB347",
  "#87CEEB", "#FF8C00", "#32CD32",
];

export const shuffleArray = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

// Sound effects
const audioCtx = typeof window !== 'undefined' ? new (window.AudioContext || window.webkitAudioContext)() : null;
const playTone = (freq, dur, type = 'sine', vol = 0.25) => {
  if (!audioCtx) return;
  try {
    if (audioCtx.state === 'suspended') audioCtx.resume();
    const o = audioCtx.createOscillator();
    const g = audioCtx.createGain();
    o.type = type; o.frequency.setValueAtTime(freq, audioCtx.currentTime);
    g.gain.setValueAtTime(vol, audioCtx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + dur);
    o.connect(g); g.connect(audioCtx.destination);
    o.start(); o.stop(audioCtx.currentTime + dur);
  } catch (err) { logger.debug("audio/data op failed", err); }
};

export const playPopSound = () => { playTone(900, 0.06, 'sine', 0.15); };
export const playWhackCorrect = () => {
  playTone(523, 0.08, 'sine', 0.3);
  setTimeout(() => playTone(784, 0.1, 'sine', 0.3), 60);
  setTimeout(() => playTone(1047, 0.15, 'sine', 0.3), 130);
};
export const playWhackWrong = () => {
  playTone(200, 0.12, 'square', 0.15);
  setTimeout(() => playTone(160, 0.15, 'square', 0.15), 100);
};
export const playComboSound = () => {
  playTone(1047, 0.08, 'sine', 0.2);
  setTimeout(() => playTone(1319, 0.1, 'sine', 0.2), 60);
  setTimeout(() => playTone(1568, 0.12, 'sine', 0.2), 120);
};
export const playTimeUpSound = () => {
  playTone(400, 0.2, 'triangle', 0.2);
  setTimeout(() => playTone(300, 0.3, 'triangle', 0.2), 150);
};
export const playGameOverSound = () => {
  const notes = [1047, 988, 880, 784, 698, 659, 587, 523];
  notes.forEach((n, i) => setTimeout(() => playTone(n, 0.15, 'sine', 0.2), i * 80));
};

export const speakWhack = (text) => {
  if (!window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = getVoiceLang(); u.rate = 0.85; u.pitch = 1.0; u.volume = 1.0;
  window.speechSynthesis.speak(u);
};
